
import { mdiChevronUp } from "@mdi/js";

export default {
  name: "ScrollToTopButton",

  props: {
    bottomPosition: {
      type: [Number, String],
      default: 20,
    },
    leftPosition: {
      type: [Number, String],
      default: null,
    },
    rightPosition: {
      type: [Number, String],
      default: 20,
    },
    scrollThreshold: {
      type: Number,
      default: 300,
    },
  },

  data() {
    return {
      visible: false,
      mdiChevronUp,
    };
  },

  computed: {
    buttonStyle() {
      return {
        bottom: `${this.bottomPosition}px !important`,
        left:
          this.leftPosition !== null
            ? `${this.leftPosition}px !important`
            : "auto !important",
        right:
          this.rightPosition !== null
            ? `${this.rightPosition}px !important`
            : "auto !important",
      };
    },
  },

  mounted() {
    window.addEventListener("scroll", this.checkScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.checkScroll);
  },

  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    checkScroll() {
      this.visible = window.scrollY > this.scrollThreshold;
    },
  },
};
